import React from 'react';
const GroupContext = /*#__PURE__*/React.createContext(null);
export default GroupContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/checkbox/GroupContext.js
// module id = 762
// module chunks = 0